import React from 'react'
import { Button, Space } from 'antd'
import { SBRMAction, SBRMType } from '../SBRMModel'
import LocalizationKeys from '../../../i18n/LocalizationKeys'
import i18n from '../../../i18n/setupLocalization'

interface Props {
  isLoading: boolean
  entity: SBRMType | undefined
  action: SBRMAction
  onSave: () => void
  onUpdate: () => void
  onDelete: () => void
  onClose: () => void
  style?: React.CSSProperties
  displayCloseButton?: boolean
}

const SBRMActionsWrapper = ({
  isLoading,
  entity,
  action,
  onSave,
  onUpdate,
  onClose,
  onDelete,
  style,
  displayCloseButton = true,
}: Props) => {
  return (
    <div style={style}>
      <Space className="p-2 text-right">
        {displayCloseButton && (
          <Button onClick={onClose} disabled={isLoading}>
            {i18n.t(LocalizationKeys.SBRM.Close)}
          </Button>
        )}
        {entity && (action === 'create' || action === 'duplicate') && (
          <Button onClick={onSave} type="primary" loading={isLoading}>
            {i18n.t(LocalizationKeys.SBRM.Save)}
          </Button>
        )}
        {entity && action === 'update' && (
          <Button
            onClick={onUpdate}
            type="primary"
            color="secondary"
            loading={isLoading}
          >
            {i18n.t(LocalizationKeys.SBRM.Save)}
          </Button>
        )}
        {entity && action === 'delete' && (
          <Button danger onClick={onDelete} type="primary" loading={isLoading}>
            {i18n.t(LocalizationKeys.SBRM.Delete)}
          </Button>
        )}
      </Space>
    </div>
  )
}

export default SBRMActionsWrapper
